<template>
    <layout>
        <rdkm-title>
            {{ $t('Организации') }}
            <router-link tag="span" to="/organizations/add">
                <b-button class="float-right" right size="sm" variant="primary">
                    <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
                </b-button>
            </router-link>
        </rdkm-title>
        <div class="tile">
            <filter-form :name="query.name" 
                        :group="query.group"
                        :code="query.code"
                        :isActive="query.isActive" 
                        v-on:search="$refs.grid.filter($event)">
            </filter-form>
            <rdkm-grid ref="grid" :state="query">
                <grid-column name="code" :title="$t('Код')" cell="edit-cell" width="120"></grid-column>
                <grid-column name="group" :title="$t('Тип')"></grid-column>
                <grid-column name="name" :title="$t('Название')"></grid-column>
                <grid-column name="city" :title="$t('Город')"></grid-column>
                <grid-column name="address" :title="$t('Адрес')"></grid-column>
                <grid-column name="contacts" :title="$t('Контакты')"></grid-column>                
                <grid-column name="active" :title="$t('Действующая')"></grid-column>                
            </rdkm-grid>
        </div>
    </layout>
</template>

<script>
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';

export default {
  name: 'Organizations',
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
  },
};
</script>
